import React from 'react'
import { FormDashboardInput, FormDashboardInputNumber as InputNumber } from '../../../components';
import { viewportBreakpoint, useViewport } from '../../../utils';

const Row = ({data}) => {
  const { width } = useViewport()
  const isMobile = width < viewportBreakpoint.tablet

  return (
    <tr>
      <td>
        <div className="flex items-center">
          <div className="mr-3" style={{width: isMobile ? '160px' : 'auto'}}>
            <FormDashboardInput defaultValue={data.name} className="py-2 w-full lg:w-auto"/>
          </div>
          <div style={{width: isMobile ? '73px' : '100px'}}>
            <InputNumber className="w-full"/>
          </div>
        </div>
      </td>
      <td width="30%">
        <div className="flex justify-end py-2 lg:py-0">
          <p className="cursor-pointer underline text-sm text-gray-999">Delete</p>
        </div>
      </td>
    </tr>
  )
}

const SatisfactionInput = () => {
  return (
    <table className="table table--striped">
      <tbody className="text-sm">
        <Row data={{name: 'Sangat puas'}}/>
        <Row data={{name: 'Tidak puas'}}/>
        <Row data={{name: 'Lainnya'}}/>
      </tbody>
    </table>
  )
}

export { SatisfactionInput }